import { createContext, useState } from "react";

export const LastItemContext = createContext();

export const LastItemProvider = ({ children }) => {
  const [lastitemnumber, setLastitemNumber] = useState(null);
  // Valor específico para pesquisas do tipo "inicial" (featuredInitial = true)
  const [lastItemNumberInitial, setLastItemNumberInitial] = useState(null);
  return (
    <LastItemContext.Provider value={{
      lastitemnumber,
      setLastitemNumber,
      lastItemNumberInitial,
      setLastItemNumberInitial,
    }}>
      {children}
    </LastItemContext.Provider>
  );
};
export default LastItemProvider;
